@if (loadingService.isLoading()) {
  <div class="global-loader" role="status" aria-live="polite" aria-label="Loading portal content">
    <div class="global-loader__panel">
      <div class="global-loader__mark" aria-hidden="true"><span></span></div>
    </div>
  </div>
}
